// extracted by mini-css-extract-plugin
export var aircallIframe = "_ck-3";
export var fabContainer = "_ck-5";
export var fabRinging = "_ck-6";
export var loadingOverlay = "_ck-4";
export var pulse = "_ck-7";
export var widgetContent = "_ck-2";
export var widgetPanel = "_ck-0";
export var widgetPanelExpanded = "_ck-1";